module.exports = __webpack_public_path__ + "img/categories-and-zones.a6e8a01e.svg";